import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import { Button } from 'react-bootstrap';
import CustomPlanPricingForm from './CustomPlanPricingForm';
import FormError from './FormError';

let RemoteSubmitButton = ({ dispatch }) => (
  <Button
    type="button"
    bsStyle="primary"
    onClick={() => dispatch(submit('customPlanPricing'))}
  >
    Save
  </Button>
);
RemoteSubmitButton = connect()(RemoteSubmitButton);

const CustomPlanPricingUpdateModal = ({
  isOpen,
  onClose,
  onConfirm,
  customPlanPricing,
  error,
}) => {
  const handleSubmit = (form) => onConfirm(form);

  const initialValues = { ...customPlanPricing };

  return (
    <ReactModal
      appElement={document.getElementById('root')}
      isOpen={isOpen}
      contentLabel="Custom Plan Pricing Delete Modal"
      portalClassName="AdjustmentCreditPortal"
      overlayClassName="AdjustmentCreditModal__Overlay"
      className="AdjustmentCreditModal__Content"
    >
      <div className="modal-header">
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <h2>Update custom plan pricing:</h2>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to update this custom plan pricing?</p>
        <br />
        <CustomPlanPricingForm
          onSubmit={handleSubmit}
          initialValues={initialValues}
          isUpdateModal
        />
        {error && <FormError error={error} />}
      </div>

      <div className="modal-footer">
        <RemoteSubmitButton />
        <Button onClick={onClose}>Cancel</Button>
      </div>
    </ReactModal>
  );
};

export default CustomPlanPricingUpdateModal;
